export var TABS = 'Tabs';